module.exports = __webpack_public_path__ + "static/media/iternal_box.4f1b7b22.svg";